(() => {
  angular
    .module('app')
    .controller('host.views.employees.providerListModal', ProviderListController);

  ProviderListController.$inject = [
    '$scope', 
    '$uibModalInstance'
  ];

  function ProviderListController(
    $scope, 
    $uibModalInstance
  ) {
    const vm = this;
    vm.placeholderDisplay = 'Insert panel name / code / contact number / address to search';
    vm.loading = 0;

    vm.getProviderList = getProviderList;
    
    function init() {
      // TODO HM-10233: ProviderList currently does not exist and is hidden from view.
      // Values displayed are placeholder.
    }

    function getProviderList() {

    }

    vm.close = function close() {
      $uibModalInstance.close();
    };

    init();
  }
})();
